import React from 'react'
import { Helmet } from "react-helmet"

const SEO = () => {
    return (
        <div>
            <Helmet>
                <title>Diamonds Consulting - Business Analytics & ERP Implementations</title>
                <meta name="description" content="Diamonds Consulting helps you implement business analytics and ERP Implementation projects using modern best practices and accelerators to help your projects succeed in time and budget." />
                <meta name="og:title" property="og:title" content="Diamonds Consulting - Business Analytics & ERP Implementations"></meta>
                <meta name="twitter:card" content="Diamonds Consulting - Business Analytics & ERP Implementations"></meta>
                <link rel="canonical" href="https://rewy-react.envytheme.com/"></link>
                <meta property="og:image" content="https://res.cloudinary.com/dev-empty/image/upload/v1593069801/explore-learning.jpg" />
            </Helmet>
        </div>
    )
}

export default SEO
